//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect, useContext } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { AppContext, LayoutContext } from '../common/contexts';
import { PATH_ADMIN_UTIL } from '../system/constants';
import { ADMIN_JOB_LISTING_STATUS, ADMIN_UTIL_ID_JOB_LISTING_STATUS, BASE_URL } from '../common/constants';
import { setClassNameInDefns } from '../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import AdminNavigationButton from '../AdminConsole2/subComponents/AdminNavigationButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import JobListingStatusEdit from './subComponents/JobListingStatusEdit';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import _get from 'lodash/get';
import { handleCloseSnackbar } from '../common/snackbarHelper';
import AfitdSnackbar from '../common/elemental/AfitdSnackbar';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {},
        sidebarContainer: {
            display: 'flex',
            justifyContent: 'center',
            background: 'white',
            height: '100%',
            overflowY: 'auto',
        },

        sidebarNavItem: { fontSize: 15, color: '#9B9E9C' },
        sidebarItem: { marginTop: 66, maxWidth: 225, marginRight: 32 },
    }));
};
const handleClickButton = (history, path) => {
    history.push(`${BASE_URL}${PATH_ADMIN_UTIL}/${path}`);
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, snackbarMessage, setSnackbarMessage, snackbarErrorMessage, setSnackbarErrorMessage, history, adminPageId } = params;

    const defns = {
        sidebarContainer: { container: true },
        sidebarItem: { item: true, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 },
        snackbar: {
            message: { successMessage: snackbarMessage, errorMessage: snackbarErrorMessage },
            onClose: handleCloseSnackbar.bind(null, setSnackbarMessage, setSnackbarErrorMessage),
        },

        jobListingStatus: {
            label: ADMIN_JOB_LISTING_STATUS,
            selected: adminPageId === ADMIN_UTIL_ID_JOB_LISTING_STATUS,
            onClick: handleClickButton.bind(null, history, ADMIN_UTIL_ID_JOB_LISTING_STATUS),
            // caption: 1,
            // isCaption: true,
        },
        moreComing: {
            label: 'More Coming',
            selected: adminPageId === '99999',
            onClick: handleClickButton.bind(null, history, 99999),
            // caption: 1,
            // isCaption: true,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const getLayoutComponent = adminPageId => {
    switch (adminPageId) {
        case ADMIN_UTIL_ID_JOB_LISTING_STATUS:
            return <JobListingStatusEdit />;
        case '99999':
            return <div>More Coming Placeholder</div>;
        default:
            return <div>placeholder</div>;
    }
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const AdminUtilLayout = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const { pageId = ADMIN_UTIL_ID_JOB_LISTING_STATUS } = useParams();
    const history = useHistory();
    const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const isSuperUser = _get(appContext, 'currentUser.superUser');

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    // const layoutContext = useContext(LayoutContext);
    // const { scrollToPageTop } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [snackbarMessage, setSnackbarMessage] = useState();
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState();
    const [OpenFaqDropdown, setOpenFaqDropdown] = useState(false);
    const [adminPageId, setAdminPageId] = useState(pageId);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        // const init = async () => {
        //     const counts = await loadTotalCounts();
        //     setTotalCounts(counts);
        // };
        // const init2 = async () => {
        //     const todayCount = await loadTodaysCount();
        //     setTodayCount(todayCount);
        // };
        // init();
        // init2();
    }, []);

    useEffect(() => {
        if (pageId) {
            setAdminPageId(pageId);
        } else {
            setAdminPageId(ADMIN_UTIL_ID_JOB_LISTING_STATUS);
        }
    }, [pageId]);

    // useEffect(() => {
    //     scrollToPageTop();
    // }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        snackbarMessage,
        setSnackbarMessage,
        snackbarErrorMessage,
        setSnackbarErrorMessage,
        history,
        OpenFaqDropdown,
        setOpenFaqDropdown,
        adminPageId,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return isSuperUser ? (
        <LayoutContext.Provider value={{ snackbarMessage, setSnackbarMessage, snackbarErrorMessage, setSnackbarErrorMessage }}>
            <Grid {...defns.sidebarContainer}>
                <Grid {...defns.sidebarItem}>
                    <div {...defns.sidebarNavItem}>
                        <AdminNavigationButton {...defns.jobListingStatus} />
                    </div>
                    <div {...defns.sidebarNavItem}>
                        <AdminNavigationButton {...defns.moreComing} />
                    </div>
                </Grid>
                {/* content section */}
                {getLayoutComponent(adminPageId)}
            </Grid>
            <AfitdSnackbar {...defns.snackbar} />
        </LayoutContext.Provider>
    ) : (
        <div>Access denied</div>
    );
};

export default AdminUtilLayout;
